<template>
  <div class="chat-faq-box">
    <div class="infos">
      <div class="title">
        感谢您的来访，长按下方二维码添加客服企业微信，以便于了解更多游戏内容！
      </div>
      <div v-if="data.link" class="desc">
        点击下方按钮，添加“Hero福利官”好友~
      </div>
      <div v-else class="desc">长按识别二维码，添加“Hero福利官”好友~</div>
    </div>
    <div class="qr-code">
      <template v-if="data.link">
        <div class="title no-border" @click="handleOpenUrl">
          点击添加“Hero福利官”
        </div>
      </template>
      <template v-else>
        <div class="title">添加“Hero福利官”好友</div>
        <div class="img-box">
          <div class="img">
            <img :src="data.qr_code" alt="二维码" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handleOpenUrl() {
      window.open(this.data.link);
    },
  },
};
</script>
<style lang="less" scoped>
.chat-faq-box {
  width: calc(100% - 50px);
  margin: 7.5px 0;

  .infos {
    margin-bottom: 8px;
    padding: 10px;
    border-radius: 15px;
    border-top-left-radius: 0 15px;
    background-color: #fff;
    .title {
      margin-bottom: 2px;
      padding-bottom: 9px;
      color: #333;
      font-size: 14px;
      line-height: 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    }
    .desc {
      color: #666;
      font-size: 12px;
      // line-height: 14px;
    }
  }
  .qr-code {
    width: 148px;
    border-radius: 15px;
    background-color: #fffaf1;
    .title {
      margin-bottom: 8px;
      padding: 8px;
      color: #bb821a;
      font-size: 12px;
      // line-height: 16px;
      border-bottom: 1px dashed #f6dfb4;
      box-sizing: border-box;
      text-align: center;
      &.no-border {
        // padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: none;
        text-decoration: dashed;
      }
    }
    .img-box {
      padding: 8px;
      padding-top: 0;
      .img {
        width: 100%;
        padding: 2px;
        box-sizing: border-box;
        border: 2px solid #bb821a;
        border-radius: 10px;
        box-sizing: border-box;
        img {
          width: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
